import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import Page from '../components/Page';
import PageTitle from '../components/PageTitle';

const CreateOpportunityNavigator = () => {
  const { t } = useTranslation();

  return (
    <Page>
      <PageTitle
        title={t('Nova Vaga')}
        footer={
          <Tabs
            activeKey="general"
            items={[
              { key: 'general', label: t('Geral') },
              { key: 'profile', label: t('Perfil'), disabled: true },
              { key: 'description', label: t('Descrição da vaga'), disabled: true },
              { key: 'stages', label: t('Fluxo de etapas'), disabled: true },
              { key: 'publication', label: t('Publicação'), disabled: true },
            ]}
          />
        }
      />
      <Outlet />
    </Page>
  );
};

export default CreateOpportunityNavigator;
